<div class="container">
  <div class="row">
    <div class="col">
      <h2 class="fw-extrabold">Find a specialist</h2>
      <p>
        The search tool and results are provided independently by Healthgrades™.
        Sanofi does not endorse or recommend any particular physician and search
        results may not include a comprehensive list of doctors in your area.
        Sanofi is not responsible for any Healthgrades content.
      </p>
      <!-- start widget code -->
      <div id="hghcp" class="healthgrades-widget">
        <!-- Widget content will be injected here by the external script -->
      </div>
      <!-- end widget code -->
    </div>
  </div>
</div>
